/**
 * routes/* catalog registry for the `en` locale (one module per route directory).
 * Generated layout: every module keeps its three locales side by side in
 * ./<module>/{fr,en,ar}.ts so each locale bundles into its own chunk.
 */

import type { RoutesCatalog } from './fr';
import admin from './admin/en';
import ads from './ads/en';
import advisor from './advisor/en';
import advocacy from './advocacy/en';
import ai from './ai/en';
import aiActivity from './aiActivity/en';
import aiAssistant from './aiAssistant/en';
import aiTeam from './aiTeam/en';
import analytics from './analytics/en';
import approvals from './approvals/en';
import auth from './auth/en';
import automations from './automations/en';
import bio from './bio/en';
import booking from './booking/en';
import calendar from './calendar/en';
import communities from './communities/en';
import community from './community/en';
import content from './content/en';
import crm from './crm/en';
import dashboard from './dashboard/en';
import design from './design/en';
import documents from './documents/en';
import email from './email/en';
import forms from './forms/en';
import geo from './geo/en';
import grants from './grants/en';
import growth from './growth/en';
import inbox from './inbox/en';
import influencers from './influencers/en';
import landing from './landing/en';
import learning from './learning/en';
import legal from './legal/en';
import listening from './listening/en';
import marketplace from './marketplace/en';
import mediaLibrary from './mediaLibrary/en';
import misc from './misc/en';
import notifications from './notifications/en';
import onboarding from './onboarding/en';
import orchestration from './orchestration/en';
import outreach from './outreach/en';
import planning from './planning/en';
import platforms from './platforms/en';
import portal from './portal/en';
import process from './process/en';
import projects from './projects/en';
import prospect from './prospect/en';
import prospection from './prospection/en';
import publishing from './publishing/en';
import reports from './reports/en';
import settings from './settings/en';
import sign from './sign/en';
import social from './social/en';
import staffQuestions from './staffQuestions/en';
import status from './status/en';
import strategyMktg from './strategyMktg/en';
import team from './team/en';
import versions from './versions/en';
import workflows from './workflows/en';

export const routesEn: RoutesCatalog = {
  admin,
  ads,
  advisor,
  advocacy,
  ai,
  aiActivity,
  aiAssistant,
  aiTeam,
  analytics,
  approvals,
  auth,
  automations,
  bio,
  booking,
  calendar,
  communities,
  community,
  content,
  crm,
  dashboard,
  design,
  documents,
  email,
  forms,
  geo,
  grants,
  growth,
  inbox,
  influencers,
  landing,
  learning,
  legal,
  listening,
  marketplace,
  mediaLibrary,
  misc,
  notifications,
  onboarding,
  orchestration,
  outreach,
  planning,
  platforms,
  portal,
  process,
  projects,
  prospect,
  prospection,
  publishing,
  reports,
  settings,
  sign,
  social,
  staffQuestions,
  status,
  strategyMktg,
  team,
  versions,
  workflows,
};
